import { createApp } from 'vue';
import App from './App.vue';
import UserMenu from './components/UserMenu.vue';
import Button from 'primevue/button';
import Menu from 'primevue/menu';
import ProgressSpinner from 'primevue/progressspinner';
import Dialog from 'primevue/dialog';
import AutoComplete from 'primevue/autocomplete';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import PrimeVue from 'primevue/config';
import 'primeicons/primeicons.css'
import presetTheme from './tailwind-presets/college-search';
import './index.css'
import './auth'
import { trackSiteVisit } from './analytics/xad';

const app = createApp(App);
app
  .use(PrimeVue, {
    unstyled: true,
    pt: presetTheme,
  })
  .component(UserMenu.name, UserMenu)
  .component(Menu.name, Menu)
  .component(Button.name, Button)
  .component(ProgressSpinner.name, ProgressSpinner)
  .component(Dialog.name, Dialog)
  .component(AutoComplete.name, AutoComplete)
  .component(DataTable.name, DataTable)
  .component(Column.name, Column)
  .component(Dropdown.name, Dropdown)
  .component(InputText.name, InputText)
  .mount('#app')

trackSiteVisit();
